























import { Component, Vue, Watch } from "vue-property-decorator";
import Header from "./Header.vue";
import Sidebar from "./Sidebar.vue";
import ImpersonationStatus from "./ImpersonationStatus.vue";
import { getSetting, setSetting } from "@/services/autoSettings/autoSettingsService";

@Component({
    components: {
        Header,
        Sidebar,
        ImpersonationStatus
    }
})
export default class Layout extends Vue {
  sideBarShrink = true as boolean;
  pinStatus = false as boolean;
  componentsAutoSettingKey = "sidebar-pin-setting";

  @Watch("$route")
  routeChanged() {
      if (this.$route.path === "/") {
          this.sideBarShrink = false;
          this.pinStatus = true;
      } else {
          this.pinStatus = getSetting(this.componentsAutoSettingKey) || false;
          if (!this.pinStatus) this.sideBarShrink = true;
          else this.sideBarShrink = false;
      }
  }

  // Computed property to check if the current route requires no padding
  get IsNoPaddingLayout() {
      return this.$route.meta.noPaddingLayout || false;
  }

  onHoverStateChange() {
      if (this.pinStatus) return;
      this.sideBarShrink = false;
  }

  offHoverStateChange() {
      if (this.pinStatus) return;
      this.sideBarShrink = true;
  }

  setPinStatus() {
      this.pinStatus = !this.pinStatus;
      setSetting(this.componentsAutoSettingKey, this.pinStatus);
  }
}
